import React from 'react'

import classnames from 'classnames'
import Immutable from 'immutable'
import PropTypes from 'prop-types'

import GoustoImage from 'components/Image'
import { ProductButtons } from 'components/Product/Buttons'
import { onSpaceOrEnter } from 'utils/accessibility'

import { ProductCategoryTags } from './ProductCategoryTags'

import css from './Product.css'

const propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  categoryTags: PropTypes.arrayOf(PropTypes.string).isRequired,
  listPrice: PropTypes.string.isRequired,
  imgSource: PropTypes.instanceOf(Immutable.List),
  lowStock: PropTypes.bool.isRequired,
  outOfStock: PropTypes.bool.isRequired,
  limitReached: PropTypes.oneOfType([
    PropTypes.shape({
      type: PropTypes.string,
      value: PropTypes.number,
    }),
    PropTypes.bool,
  ]).isRequired,
  qty: PropTypes.number.isRequired,
  ageVerificationPending: PropTypes.bool.isRequired,
  inProgress: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  openDetailsScreen: PropTypes.func.isRequired,
  canEditOrder: PropTypes.bool.isRequired,
}

const ProductPresentation = ({
  id,
  qty,
  title,
  categoryTags,
  lowStock,
  outOfStock,
  onAdd,
  onRemove,
  listPrice,
  imgSource,
  limitReached,
  openDetailsScreen,
  ageVerificationPending,
  inProgress,
  canEditOrder,
}) => (
  <div
    className={css.productDetails}
    data-testing="productItem"
    onClick={() => openDetailsScreen()}
    onKeyDown={onSpaceOrEnter(() => openDetailsScreen())}
    role="button"
    tabIndex={0}
    aria-label={title}
  >
    <div className={classnames(css.resetButtonStyle, css.productImage)}>
      {imgSource.size > 0 && (
        <GoustoImage
          className={classnames({ [css.fadedImage]: outOfStock })}
          contain={false}
          maxMediaSize={700}
          media={imgSource}
          title={title}
        />
      )}
    </div>
    {lowStock && !outOfStock && <span className={css.productLowStock}>low stock</span>}
    <div className={css.productContent}>
      <ProductCategoryTags tags={categoryTags} />
      <div className={css.productContentFirstColumn}>
        <div className={classnames(css.resetButtonStyle, css.productInfo)}>
          <h3 className={css.productTitle}>{title}</h3>
        </div>
      </div>
      <div>
        <p className={css.productPrice}>£{listPrice}</p>
        {/* This wrapper only prevents the tile click handler from firing when using the add/remove controls. */}
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <div
          className={css.productButtonWrapper}
          onClick={(event) => event.stopPropagation()}
          onKeyDown={(event) => event.stopPropagation()}
        >
          <ProductButtons
            ageVerificationPending={ageVerificationPending}
            canEditOrder={canEditOrder}
            inProgress={inProgress}
            isAvailable={!outOfStock && !limitReached && canEditOrder}
            limitReached={limitReached}
            onAdd={onAdd}
            onRemove={onRemove}
            outOfStock={outOfStock}
            productId={id}
            qty={qty}
          />
        </div>
      </div>
    </div>
  </div>
)

ProductPresentation.propTypes = propTypes

ProductPresentation.defaultProps = {
  imgSource: Immutable.List(),
}

export { ProductPresentation }
